import React, { useState } from 'react';
import { Button } from '../components/ui/Button';
import { Input } from '../components/ui/Input';
import { Card } from '../components/ui/Card';
import { LockIcon, TrophyIcon, ArrowLeftIcon } from 'lucide-react';
import { saveContactSubmission } from '../hooks/useContactSubmissions';
interface ContactGateProps {
  playerName: string;
  onUnlock: (email: string, phone: string) => void;
  onBack: () => void;
}
export function ContactGate({
  playerName,
  onUnlock,
  onBack
}: ContactGateProps) {
  const [email, setEmail] = useState('');
  const [phone, setPhone] = useState('');
  const [error, setError] = useState('');
  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    setError('');
    if (!email.trim() || !email.includes('@')) {
      setError('Please enter a valid email address.');
      return;
    }
    if (!phone.trim() || phone.replace(/\D/g, '').length < 10) {
      setError('Please enter a valid 10-digit phone number.');
      return;
    }
    // Save to localStorage for admin review
    saveContactSubmission({
      name: playerName,
      email: email.trim(),
      phone: phone.trim()
    });
    onUnlock(email.trim(), phone.trim());
  };
  return <div className="min-h-screen bg-zinc-950 flex flex-col items-center justify-center p-4" data-id="element-417">
      <div className="w-full max-w-md mb-4" data-id="element-418">
        <button onClick={onBack} className="flex items-center gap-2 text-gray-500 hover:text-white transition-colors text-sm" data-id="element-419">
          <ArrowLeftIcon className="w-4 h-4" data-id="element-420" /> Back to Results
        </button>
      </div>

      <Card className="w-full max-w-md text-center" data-id="element-421">
        <div className="mb-8" data-id="element-422">
          <div className="relative inline-block mb-4" data-id="element-423">
            <TrophyIcon className="w-16 h-16 text-yellow-500 mx-auto" data-id="element-424" />
            <div className="absolute -bottom-1 -right-1 bg-zinc-900 rounded-full p-1" data-id="element-425">
              <LockIcon className="w-5 h-5 text-gray-400" data-id="element-426" />
            </div>
          </div>
          <h2 className="text-3xl font-black text-white mb-2 uppercase tracking-tight" data-id="element-427">
            Unlock the Leaderboard
          </h2>
          <p className="text-gray-400 text-sm leading-relaxed" data-id="element-428">
            Drop your info below to see how you stack up against everyone else,{' '}
            <span className="text-white font-semibold" data-id="element-429">{playerName}</span>.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4 text-left" data-id="element-430">
          <Input label="Email Address" type="email" placeholder="you@example.com" value={email} onChange={e => setEmail(e.target.value)} autoComplete="email" data-id="element-431" />
          <Input label="Phone Number" type="tel" placeholder="(555) 000-0000" value={phone} onChange={e => setPhone(e.target.value)} autoComplete="tel" data-id="element-432" />

          {error && <p className="text-red-400 text-sm font-mono" data-id="element-433">{error}</p>}

          <Button type="submit" variant="primary" size="lg" className="w-full mt-2" data-id="element-434">
            SEE LEADERBOARD
          </Button>
        </form>

        <p className="text-gray-600 text-xs mt-6 leading-relaxed" data-id="element-435">
          We respect your privacy. Your info will only be used to notify you of
          future challenges.
        </p>
      </Card>
    </div>;
}